import Divider from '@elementor/ui/Divider';
import { memo } from 'react';
import { StyledSkeleton } from '@styles/app.styles';
import { StyledTitleRowContainer } from '@styles/heading-structure.styles';

const HeadingStructureTitleRowLoader = memo(
	function HeadingStructureTitleRowLoader() {
		return (
			<StyledTitleRowContainer
				direction="row"
				divider={<Divider orientation="vertical" flexItem />}
				gap={2}
			>
				<StyledSkeleton width={70} height={18} />
				<StyledSkeleton width={70} height={18} />
				<StyledSkeleton width={110} height={18} />
			</StyledTitleRowContainer>
		);
	},
);

export default HeadingStructureTitleRowLoader;
